
import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachMonActionsObj } from "../../action-types/ke-hoach/IKeHoachMonActions";

import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachMonActions = {
  ...generateActions(eKeHoachMonActionsObj, "KE_HOACH_MON"),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Deleted")
  }),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "DELETE_CHITIET_SUCCESS", () => {
    NotifyHelper.Success("Deleted")
  }),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "SAVE_CHITIET_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "ADDING_MONHOC_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "UPDATE_GIAI_DOAN_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachMonActionsObj, "KE_HOACH_MON", "SAVE_CHITIET_ERROR", (error: string) => {
    NotifyHelper.Error(error)
  }),
};
